module.exports = __webpack_public_path__ + "media/images/icon__facebook-b96c02a12d5d40d33ba30eb701d18de4.png";